import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http.service';

/** GET /promotion/environments */
export interface PromotionEnvironments {
  current: string;
  /** Udviklerkæden (sproglag, faste data); null i Development. */
  previous: string | null;
  /** Miljøet kundeopsætninger kan kopieres fra; null hvor konsulenter ikke må importere. */
  customerSetupSource: string | null;
}

/** Miljøkilderne som API'et kender dem — klienten må ikke gætte dem. */
@Injectable({ providedIn: 'root' })
export class PromotionService {
  private readonly http = inject(HttpService);
  private readonly apiBase = `${environment.adminConfig.apiUri}/promotion`;

  getEnvironments(): Promise<PromotionEnvironments> {
    return this.http.get<PromotionEnvironments>(`${this.apiBase}/environments`);
  }
}
